import { ContactType } from '../constants/contact-type.constants';
export interface IContact {
  type: ContactType;
  value: string | null;
}

/**
 * Contact object for request
 */
export class ContactRequest implements IContact {
  constructor(public type: ContactType, public value: string | null) {}
}

/**
 * Contact object for response from server
 */
export class ContactResponse implements IContact {
  constructor(public type: ContactType, public value: string | null, public verified?: boolean) {}
}
